const initialState = {
  error: '',
  user: null,
  shipper: null,
  credentials: null,
  loading: false,
};

const initialStateForTest = {
  error: '',
  user: null,
  shipper: null,
  credentials: null,
  loading: false,
};
export default initialState;
export { initialStateForTest };
